/**
 * A page plus the route param values a preview document is actually rendering,
 * read from its own location against its route. This is what the editor adopts,
 * and what preview history stores, so `/businesses/acme` and `/businesses/contoso`
 * are two locations of the same page rather than one.
 */
export type EditorPreviewLocation = {
  pageId: string;
  routeParams: Record<string, string>;
};

/**
 * A stable identity for a preview location, so two locations can be compared
 * (and de-duplicated in preview history) without depending on key order or
 * object identity.
 */
export function previewLocationKey(location: EditorPreviewLocation): string {
  return JSON.stringify([location.pageId, sortedRouteParams(location.routeParams)]);
}

export function routeParamsKey(routeParams: Record<string, string>): string {
  return JSON.stringify(sortedRouteParams(routeParams));
}

function sortedRouteParams(routeParams: Record<string, string>): Array<[string, string]> {
  return Object.entries(routeParams).toSorted(([left], [right]) => left.localeCompare(right));
}
